import React from 'react';

import { PersonalInformationForm } from 'src/components/account';
import { DetailPageLayout } from 'src/components/common';

export const PersonalInformationPage: React.FC = () => {
  return (
    <DetailPageLayout titleContent="Personal Information">
      <PersonalInformationForm />
    </DetailPageLayout>
  );
};
